import ProducePricesPage from "./ProducePrices";
import {
  loadFeaturedFruitIds,
  saveFeaturedFruitIds,
  fruitEmoji,
} from "../fruit_catalog";

function FruitsPage() {
  return (
    <ProducePricesPage
      title="Fruit Prices"
      itemName="fruit"
      itemNamePlural="fruits"
      apiPath="/api/fruits"
      itemsKey="fruits"
      loadFeatured={loadFeaturedFruitIds}
      saveFeatured={saveFeaturedFruitIds}
      emojiFor={fruitEmoji}
      footnote="Bangalore uses Karnataka rates; Chennai uses Koyambedu. Coimbatore, Madurai, and Oddanchatram share Tamil Nadu fruit rates. Mumbai and Delhi are not on this feed yet. Retail can vary by neighbourhood. Star a fruit to keep it in Featured."
    />
  );
}

export default FruitsPage;
